import { Box, FormControl, FormLabel, Select, Text, Flex, Divider } from '@chakra-ui/react'

export function ProductSelector({ pedidoData, selectedProduto, handleProdutoChange }) {
  const produtosDisponiveis = pedidoData?.itens?.filter((item) => item.status !== 'Troca Solicitada' && item.status !== 'Troca Recebida') || []

  return (
    <Box mb={6} p={6} shadow="md" borderWidth="1px" borderRadius="lg" bg="#3a4a53" color="white">
      <Text fontSize="lg" fontWeight="bold" mb={3}>
        Informações do Pedido
      </Text>

      <Flex direction={{ base: 'column', md: 'row' }} gap={4} mb={4}>
        <Box flex="1">
          <Text fontWeight="medium" mb={1}>
            Número da Nota:
          </Text>
          <Text>{pedidoData?.numero_nota}</Text>
        </Box>

        <Box flex="1">
          <Text fontWeight="medium" mb={1}>
            Cliente:
          </Text>
          <Text>{pedidoData?.nome_cliente}</Text>
        </Box>

        <Box flex="1">
          <Text fontWeight="medium" mb={1}>
            Data do Pedido:
          </Text>
          <Text>{new Date(pedidoData?.data_pedido).toLocaleDateString('pt-BR')}</Text>
        </Box>
      </Flex>

      <Divider my={4} borderColor="whiteAlpha.400" />

      <FormControl isRequired>
        <FormLabel>Selecione o Produto para Troca</FormLabel>
        <Select
          placeholder="Selecione um produto"
          value={selectedProduto}
          onChange={handleProdutoChange}
          bg="#4a5a64"
          focusBorderColor="#37F091"
          disabled={produtosDisponiveis.length === 0}
        >
          {produtosDisponiveis.map((item) => (
            <option key={item.sequencia} value={item.sequencia}>
              {item.descricao || item.descricao_produto} (Código: {item.codigo_produto}, Qtd: {item.quantidade})
            </option>
          ))}
        </Select>

        {produtosDisponiveis.length === 0 ? (
          <Text fontSize="sm" color="red.300" mt={2}>
            Não há produtos disponíveis para troca neste pedido.
          </Text>
        ) : (
          <Text fontSize="sm" color="gray.400" mt={2}>
            Selecione o produto que deseja solicitar troca
          </Text>
        )}
      </FormControl>
    </Box>
  )
}
